import React, { useContext, useState, useEffect } from 'react';
import { makeStyles, Button } from '@fluentui/react-components';
import type { ButtonProps } from "@fluentui/react-components";
import { GameSettingsContext } from './BridgeEngineSettings';
import { PlayStateContext, TurnOutcome, TurnMode } from './BridgeEnginePlay';
import './TableControls.css';

const guessButtonStyles = makeStyles({
    button: {
        height: '2.75em', 
        fontSize: '0.75em',
    },
});

const TableControls: React.FC = () => {
    const gameSettingsContext = useContext(GameSettingsContext)!;
    const { gameSettings } = gameSettingsContext;
    
    const playStateContext = useContext(PlayStateContext)!;
    const [turnState, setTurnState] = useState(playStateContext.turnState);

    useEffect(() => {
        setTurnState(playStateContext.turnState);
    }, [playStateContext.turnState]);


    const handleGuessButtonClick = () => {
        playStateContext.nextGuess();
    }

    const handleReplayButtonClick = () => {
        playStateContext.newGame();
    }

    const handleContinueButtonClick = () => {
        playStateContext.doneReviewing();
    }

    const styles = guessButtonStyles();
    const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let tableControlButtonProps: ButtonProps = {
        className: styles.button,
        size: fontSize < 15 ? 'small' : 'medium',
    };

    return (
        <>
            {turnState.playMode === TurnMode.Playing &&
                <div className='div-table-controls'>
                    <Button {...tableControlButtonProps} 
                        onMouseDown={handleGuessButtonClick}>
                            {gameSettings.maxTurns !== turnState.guessCount ? `Guess #${turnState.guessCount}` : 'Last Guess!'}
                    </Button>
                </div>
            }
            {turnState.playMode === TurnMode.Finished && (
                <div className='div-table-controls'>
                    <div className='you-x-text'>
                        {turnState.turnOutcome === TurnOutcome.Win ? 'You Win!' : 'You Lose.'}
                    </div>
                    <Button {...tableControlButtonProps}
                        onMouseDown={handleReplayButtonClick}>
                            Play again?
                    </Button>
                </div>
            )}
            {turnState.playMode === TurnMode.Reviewing && (
                <div className='div-table-controls'>
                    <div className='you-x-text'>
                        Reviewing #{turnState.reviewTurn}...
                    </div>
                    <Button {...tableControlButtonProps}
                        onMouseDown={handleContinueButtonClick}>
                        Play on?
                    </Button>
                </div>
            )}
        </>
    );
};

export default TableControls;